import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateMarketForLead as UpdateMarketForLeadMutation,
    UpdateMarketForLead_leadMarketUpdate_lead_market as Market,
    UpdateMarketForLeadVariables,
} from 'nutshell-graphql-types';

import UPDATE_MARKET_FOR_LEAD from '../mutations/update-market-for-lead.graphql';

export const useUpdateMarketForLead = (): {
    updateMarketForLead: (leadId: string, market: Market) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateMarketForLead, {loading, error}] = useMutation<
        UpdateMarketForLeadMutation,
        UpdateMarketForLeadVariables
    >(UPDATE_MARKET_FOR_LEAD);

    return {
        updateMarketForLead: (leadId: string, market: Market) =>
            updateMarketForLead({
                variables: {
                    input: {
                        lead: leadId,
                        market: market.id,
                    },
                },
                optimisticResponse: {
                    leadMarketUpdate: {
                        __typename: 'LeadMarketUpdatePayload',
                        lead: {
                            __typename: 'Lead',
                            id: leadId,
                            market,

                            // These values can't be included in the optimistic
                            // response, so Apollo will continue to use the
                            // existing values until the server response is
                            // received
                            // @ts-expect-error
                            products: undefined,
                            // @ts-expect-error
                            value: undefined,
                            // @ts-expect-error
                            valueMode: undefined,
                        },
                    },
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
